/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-08 10:46:34
 * @LastEditTime : 2019-12-20 17:29:35
 * @LastEditors  : Please set LastEditors
 */
import axios from 'axios'
import router from '../router'
// import Vue from 'vue/types/vue';
// import store from '../store'
import { Notification } from 'element-ui'
import { getToken } from '@/utils/auth'
const baseURL = process.env.NODE_ENV === 'production' ? 'https://pf.sootang.com/service-api' : '/api'

/**
 * 创建异步请求实例对象
 */
const axiosObj = axios.create({
  baseURL: baseURL,
  timeout: 1000 * 30, // 响应时间
  withCredentials: true, // 表示跨域请求时是否需要使用凭证(没发现有啥用)
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

// 全局请求拦截器
axiosObj.interceptors.request.use(
  config => {
    // console.log(getToken())
    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    // 跳转error页面
    router.push({ path: '/error' })
    return Promise.reject(error)
  }
)
// 全局响应拦截器
axiosObj.interceptors.response.use(
  res => {
    if (res.data.status === 401) {
      // 401表示没有登录
      // 提示没有登录
      // Vue.prototype.notifyError(res.data.msg)
      Notification.error({
        title: '请先登录',
        duration: 3000
      })
      // 修改vuex的showLogin状态,显示登录组件
      // store.dispatch('setShowLogin', true)
    }
    if (res.data.status === 500) {
      // 500表示服务器异常
      // 跳转error页面
      // router.push({ path: '/error' })
      Notification.error({
        title: '服务器异常',
        duration: 3000
      })
    }
    return res
  },
  error => {
    // 跳转error页面
    router.push({ path: '/error' })
    return Promise.reject(error)
  }
)

console.log('````````````')
console.log(axiosObj)
export default axiosObj



// WEBPACK FOOTER //
// ./src/request/index.js